// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"3e1798f1","724":"03b73bf5"}[chunkId] + ".chunk.js";
};